import React from 'react';
import FspStylePageHero from '@components/v5/FspStylePageHero/index';
import * as heroTagStyles from './heroTags.module.scss';
import { ICONS } from './iconRegistry';

// Reuses the exact hero used on /software-development-fellowship-program/ —
// same component, same layout, only the copy/tags change and the generic
// "Assured Referrals / Fully Online / Developers Trained" stat banner is
// suppressed (via customBanner) since it doesn't apply to this program.
const program = { PrimaryProgramID: 'AI_ENGINEER_FELLOWSHIP' };

// The shared hero's h2 (subTitle) is hardcoded to font-black + a bright
// green + capitalize — that doesn't match this page's dark-green, bold-not-
// black spec. An inline-styled span overrides size/weight/color/case without
// touching the shared component (used by other pages too), but RawHTML wraps
// it in a plain <div> that still inherits the h2's own font-size (34px) for
// its line-box "strut" — that invisible strut, not this span's line-height,
// is what was forcing a huge gap between the two wrapped lines. `display:
// block` gives the span its own line-box context so its own 20px/1.1 actually
// governs line spacing instead of the ancestor's inherited metrics.
const SUBTITLE_STYLE =
  'display:block;font-size:20px;font-weight:700;text-transform:none;color:#07634C;line-height:1.1';

const AiEngineerFellowshipHero = ({ sale, content }) => {
  const tags = content.tags.map(({ icon, label }) => {
    const Icon = ICONS[icon];
    return (
      <span className={heroTagStyles.tag} key={label}>
        {Icon && <Icon size={14} aria-hidden="true" />}
        {label}
      </span>
    );
  });

  return (
    <div className={heroTagStyles.wrap}>
      <FspStylePageHero
        program={program}
        title={content.titleHtml}
        subTitle={`<span style="${SUBTITLE_STYLE}">${content.subtitle}</span>`}
        description={content.descriptionHtml}
        tags={tags}
        sale={sale}
        showOpenForm
        customBanner={<></>}
      />
    </div>
  );
};

export default AiEngineerFellowshipHero;
